import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subject, Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { VDealer } from 'src/app/models/entities/v-dealer';
import { DealerService } from 'src/app/services/dealer.service';

@Component({
  selector: 'app-dealer',
  templateUrl: './dealer.component.html',
  styleUrls: ['./dealer.component.css']
})
export class DealerComponent implements OnInit {

  destroy$ = new Subject<void>();
  deleteModal: boolean;
  dealerId: number;
  dealers$: Observable<VDealer[]>;
  @ViewChild('dt', { static: false }) dt: any;
  constructor(private dealerService: DealerService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.getList();
  }

  getList() {
    this.dealers$ = this.dealerService.getList().pipe(map(result => result.data));
  }

  applyFilterGlobal($event: Event, stringVal: string) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, 'contains');
  }

  showDeleteModal(dealerId: number) {
    this.deleteModal = true;
    this.dealerId = dealerId;
  }

  deleteDealer() {
    this.deleteModal = false;
    this.dealerService.delete(this.dealerId).pipe(takeUntil(this.destroy$)).subscribe(
      result => {
        this.toastrService.success(result.message, "BAŞARILI!");
        this.getList();
      },
      er => {
        this.toastrService.error(er.error.message, "HATA!");
      }
    )
  }

}
